export default __webpack_public_path__ + "static/media/Faze Three Autofab Limited .d0327a2d.jpg";